import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  //页面跳转显示在顶部
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'details_h5',
      component: ()=>import('@/pages/special/details_h5')
    },
    {
      path: '/detail',
      name: 'details',
      component: ()=>import('@/pages/special/details_h5_test')
    },
    {
      path: '/appDownload',
      name: 'appDownload',
      component: ()=>import('@/pages/special/download_h5')
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js